import { Container, Section, H2 } from 'fractals'
import { Box } from '@mui/material'
import { handsSign, Phone, TestimonialCard, testimonials } from './fractals'

const CommunitySupport = () => {
  return (
    <Section id='community-support' spacingVariant='beta' colorsVariant='delta'>
      <Container
        styles={{
          boxSizing: 'border-box',
          '@media (min-width: 760px)': {
            padding: 0
          }
        }}>
        <Box
          borderRadius='16px'
          p='80px'
          display='grid'
          gridTemplateColumns='595px 403px'
          gridTemplateAreas={`
            "title   phone"
            "content phone"
          `}
          gap='32px 25px'
          overflow='hidden'
          position='relative'
          zIndex={1}
          sx={{
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundImage: `url(${handsSign.default.src})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              zIndex: '0',
              '@media (max-width: 1280px)': {
                backgroundPosition: '100%'
              },
              '@media (max-width: 768px)': {
                backgroundPosition: '75%'
              },
              '@media (max-width: 480px)': {
                transform: 'scaleX(-1)',
                backgroundPosition: '69%'
              }
            },
            '@media (max-width: 1280px)': {
              padding: '32px',
              gridTemplateColumns: 'auto 344px',
              gridTemplateAreas: `
                "title   title"
                "content phone"
              `,
              columnGap: '20px'
            },
            '@media (max-width: 768px)': {
              gridTemplateColumns: 'auto 257px',
              columnGap: '15px'
            },
            '@media (max-width: 638px)': {
              padding: '32px',
              gap: '32px',
              gridTemplateAreas: `
                "title"
                "content"
                "phone"
              `,
              gridTemplateColumns: 'auto',
              gridTemplateRows: 'auto auto 440px'
            },
            '@media (max-width: 480px)': {
              padding: '24px',
              gap: '24px',
              gridTemplateRows: 'auto auto 338px'
            }
          }}>
          <H2 variant='communitySupportTitle'>
            Поддержка и комьюнити для участников курса
          </H2>
          <Box
            display='flex'
            flexDirection='column'
            maxWidth='470px'
            gap={2}
            gridArea='content'
            sx={{
              gap: '16px',
              '@media (max-width: 1280px)': {
                gap: '14px',
                maxWidth: 'unset'
              },
              '@media (max-width: 768px)': {
                gap: '16px'
              },
              '@media (max-width: 480px)': {
                gap: '8px'
              }
            }}>
            {testimonials.map((text, index) => (
              <TestimonialCard text={text} key={`${index + 1}`} />
            ))}
          </Box>
          <Phone />
        </Box>
      </Container>
    </Section>
  )
}

export default CommunitySupport
